<template>
    <CardPage :section="10" :page="6" :nextDisabled="nextDisabled">
        <p>
            Here are some tips!
        </p>
        <p>
            Remember: HIV is spread through certain bodily fluids: blood, semen (in pre-cum and cum), and vaginal fluids when they come into contact with a
            mucous membrane or broken (or torn) tissue. Mucous membranes are found inside certain body parts, such as the rectum (butt hole), vagina, penis and
            mouth.
        </p>
        <Carousel :length="riskLevelsOrder.length" @change="change">
            <template v-slot:default="slotProps">
                <div>
                    <span class="font-weight-bold">{{ riskLevels[riskLevelsOrder[slotProps.index]].title }}</span>
                    {{ riskLevels[riskLevelsOrder[slotProps.index]].text }}
                </div>
                <v-container fluid grid-list-xs px-0>
                    <v-layout row wrap justify-center>
                        <v-flex
                            v-for="(k, i) in riskLevelsOrder"
                            :key="i"
                            :class="{ unselected: riskLevels[k].title !== riskLevels[riskLevelsOrder[slotProps.index]].title }"
                            xs3
                        >
                            <ResponsiveImage :src="riskLevels[k].image" layout="" flex="" :alt="riskLevels[k].title"></ResponsiveImage>
                            <div class="font-weight-bold text-xs-center caption black--text">{{ riskLevels[k].title }}</div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </template>
        </Carousel>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        riskLevels: get('section10/riskLevels'),
        riskLevelsOrder: get('section10/riskLevelsOrder'),
        allRiskLevelsVisited: get('section10/allRiskLevelsVisited')
    },
    methods: {
        change(index) {
            this.$store.set(`section10/riskLevels@${index + 1}.visited`, true);
        },
        nextDisabled() {
            return !this.allRiskLevelsVisited;
        }
    }
};
</script>

<style scoped>
.unselected {
    opacity: 0.5;
}
</style>
